import styled from '@emotion/styled';
import { Table } from 'antd';

export const BodyContainer = styled.div`
  width: 100%;
  padding: 10px;
`;

export const MainContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  background-color: white;
  border: 1px solid #e8e8e8;
`;

export const CustomTable = styled(Table)`
  .ant-table-thead {
    background-color: #ffffff;
    color: blue;
    height: 70px;
  }

  .ant-table-row {
    &:hover {
      background-color: #e6f7ff; /* Example of row hover effect */
    }
  }
`;
